// Shared native rail: the homepage and specialist gallery use identical controls.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-home-recommended]').forEach((section) => {
        const track = section.querySelector('[data-recommended-track]');
        const previous = section.querySelector('[data-recommended-prev]');
        const next = section.querySelector('[data-recommended-next]');
        if (!track || !previous || !next) return;

        const updateControls = () => {
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
            previous.disabled = track.scrollLeft <= 1;
            next.disabled = track.scrollLeft >= maxScroll - 1;
            previous.hidden = next.hidden = maxScroll <= 1;
        };
        const scrollByCard = (direction) => {
            const card = track.querySelector('.home-recommended__item');
            const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => scrollByCard(-1));
        next.addEventListener('click', () => scrollByCard(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                event.preventDefault();
                scrollByCard(event.key === 'ArrowLeft' ? -1 : 1);
            }
        });
        if ('ResizeObserver' in window) {
            new ResizeObserver(updateControls).observe(track);
        } else {
            window.addEventListener('resize', updateControls, { passive: true });
        }
        updateControls();
    });
});

// The mobile bar keeps the contact channels in an accessible bottom sheet.
(() => {
    const bar = document.querySelector('.ld-contactbar');
    if (!bar) return;
    const trigger = bar.querySelector('[data-contact-options]');
    const sheet = bar.querySelector('.ld-contactbar-sheet');
    const backdrop = bar.querySelector('.ld-contactbar-backdrop');
    const closeButton = bar.querySelector('.ld-contactbar-sheet-close');

    function close(restoreFocus = true) {
        if (sheet.hidden) return;
        sheet.hidden = true;
        backdrop.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('ld-contactbar-sheet-open');
        if (restoreFocus) trigger.focus();
    }

    trigger.addEventListener('click', () => {
        sheet.hidden = false;
        backdrop.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ld-contactbar-sheet-open');
        closeButton.focus();
    });
    closeButton.addEventListener('click', () => close());
    backdrop.addEventListener('click', () => close());
    sheet.addEventListener('click', event => {
        if (event.target.closest('a')) close(false);
    });
    document.addEventListener('keydown', event => {
        if (sheet.hidden) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            close();
        } else if (event.key === 'Tab') {
            const focusable = Array.from(sheet.querySelectorAll('button, a[href]'));
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    });
    document.body.addEventListener('show.bs.offcanvas', () => close(false));
    window.matchMedia('(min-width: 992px)').addEventListener('change', event => {
        if (event.matches) close(false);
    });
})();

((docs)=>{

    const myDoc = docs;
    let mediaQ = window.matchMedia(`(max-width: 991px)`);
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const header = myDoc.getElementById('siteHeader');
    const sticky = header.offsetTop;
    const onScroll = () => {
      if (window.scrollY > sticky) {
        header.classList.add("sticky");
        myDoc.body.classList.add("site-header-stuck");
      } else {
        header.classList.remove("sticky");
        myDoc.body.classList.remove("site-header-stuck");
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const galleryToolbar = myDoc.querySelector('.all-escorts-results > .gallery-list');
    const galleryGrid = myDoc.querySelector('.all-escorts-results .gallery-view');
    if (galleryToolbar && galleryGrid) {
      const updateGalleryToolbar = () => {
        if (window.innerWidth > 767) {
          myDoc.body.classList.remove('gallery-toolbar-compact');
          return;
        }

        const toolbarRect = galleryToolbar.getBoundingClientRect();
        const gridTop = galleryGrid.getBoundingClientRect().top;
        const stickyTop = parseFloat(window.getComputedStyle(galleryToolbar).top) || 0;
        const hasReachedStickyPosition = toolbarRect.top <= stickyTop + 1;
        const imagesHaveReachedToolbar = gridTop <= toolbarRect.bottom + 1;
        myDoc.body.classList.toggle(
          'gallery-toolbar-compact',
          hasReachedStickyPosition && imagesHaveReachedToolbar
        );
      };

      window.addEventListener('scroll', updateGalleryToolbar, { passive: true });
      window.addEventListener('resize', updateGalleryToolbar);
      updateGalleryToolbar();
    }



    const menuDropdown = (nai) => {
      const menu = myDoc.querySelector(nai);
      if(!menu || menu.dataset.dropdownReady === '1') return;
      menu.dataset.dropdownReady = '1';

      const offcanv = myDoc.querySelector('.nav-min');
      const mobMnuHdr = myDoc.querySelector('.nav-min-header');
      const mobMnuCloser = myDoc.querySelector('.nav-min-close');
      const overlayEle = myDoc.createElement('div');
      overlayEle.className = 'overlay';
      let directoryPanelIndex = 0;

      const prepareDirectoryAccordions = (subMenu) => {
        if (!subMenu?.classList.contains('directory-dropdown-menu')) return;

        subMenu.querySelectorAll('.types-menu-heading').forEach((heading) => {
          if (heading.nextElementSibling?.tagName !== 'UL') return;
          heading.classList.add('directory-menu-heading');
          heading.setAttribute('role', 'button');
          heading.setAttribute('tabindex', '0');
          heading.setAttribute('aria-expanded', heading.parentElement.classList.contains('is-open') ? 'true' : 'false');
          heading.setAttribute('aria-controls', heading.nextElementSibling.id ||= `directory-menu-panel-${directoryPanelIndex++}`);
        });
      };

      const prepareDropdownToggle = (item) => {
        const toggle = item.querySelector(':scope > [data-nav-dropdown]');
        if (!toggle || !window.bootstrap?.Dropdown) return;

        window.bootstrap.Dropdown.getInstance(toggle)?.dispose();
        if (mediaQ.matches) {
          toggle.removeAttribute('data-bs-toggle');
        } else {
          toggle.setAttribute('data-bs-toggle', 'dropdown');
          window.bootstrap.Dropdown.getOrCreateInstance(toggle);
        }
      };

      const ensureDropdownContent = (item) => {
        // Menus are server-rendered (not deferred) so crawlers see the links;
        // Bootstrap behavior is still attached lazily on first intent.
        const subMenu = item.querySelector(':scope > .dropdown-menu');
        if (!subMenu) return null;

        prepareDropdownToggle(item);
        prepareDirectoryAccordions(subMenu);

        return subMenu;
      };

      // Hydrate before Bootstrap's document-level data API sees the click.
      menu.addEventListener('click', (e) => {
        const directoryHeading = e.target.closest('.directory-menu-heading');
        if (directoryHeading && mediaQ.matches) {
          e.preventDefault();
          e.stopPropagation();
          const section = directoryHeading.parentElement;
          const willOpen = !section.classList.contains('is-open');
          section.parentElement.querySelectorAll(':scope > .colm-list-item.is-open').forEach((openSection) => {
            openSection.classList.remove('is-open');
            openSection.querySelector(':scope > .directory-menu-heading')?.setAttribute('aria-expanded', 'false');
          });
          section.classList.toggle('is-open', willOpen);
          directoryHeading.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          return;
        }

        const childCloser = e.target.closest('.nav-min-menu-children-closer');
        if (childCloser) {
          e.preventDefault();
          childCloser.closest('.dropdown-menu')?.classList.remove('show');
          setTimeout(() => mobMnuHdr?.classList.remove('position-fixed'), 10);
          return;
        }

        const item = e.target.closest('.haveChild');
        const itemLink = e.target.closest('.haveChild > a');
        if (!item || !itemLink) return;

        const subMenu = ensureDropdownContent(item);
        if (mediaQ.matches && subMenu) {
          e.preventDefault();
          // Mobile submenus use the full-height custom panel; do not also let
          // Bootstrap's document data API toggle the same element.
          e.stopPropagation();
          subMenu.classList.add('show');
          mobMnuHdr?.classList.add('position-fixed');
        }
      }, true);

      menu.addEventListener('keydown', (e) => {
        if (mediaQ.matches && e.target.matches('.directory-menu-heading') && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          e.target.click();
        }
      });

      // Desktop menus also open on hover. Hydrate before Bootstrap handles mouseenter.
      menu.addEventListener('mouseover', (e) => {
        if (!mediaQ.matches) {
          const item = e.target.closest('.haveChild');
          if (item) ensureDropdownContent(item);
        }
      }, true);

      menu.addEventListener('show.bs.dropdown', () => {
        if (mediaQ.matches) return;
        setTimeout(() => {
          if (!myDoc.querySelector('.overlay')) {
            myDoc.body.appendChild(overlayEle);
            header.classList.add('overlay-active');
          }
        }, 0);
      });

      myDoc.addEventListener('click', (e) => {
        if (!e.target.closest('.dropdown-menu')) {
          overlayEle.remove();
          header.classList.remove('overlay-active');
        }
      });

      mobMnuCloser?.addEventListener('click', () => {
        menu.querySelectorAll('.dropdown-menu.show').forEach((subMenu) => subMenu.classList.remove('show'));
        setTimeout(() => mobMnuHdr?.classList.remove('position-fixed'), 10);
      });

      offcanv?.addEventListener('hide.bs.offcanvas', () => {
        menu.querySelectorAll('.dropdown-menu.show').forEach((subMenu) => subMenu.classList.remove('show'));
        mobMnuHdr?.classList.remove('position-fixed');
      });
    };

    menuDropdown('.nav-min-menu');

    let filter = myDoc.querySelector('.filter-btn');
    if(filter) {
      let eachClick = true;
      filter.addEventListener('click', (e) => {
        let filterPanl = myDoc.querySelector('.filter');
        let galView = myDoc.querySelector('.gallery-view');
        if(eachClick) {
          eachClick=false;
          filterPanl.classList.add('show');
          galView.classList.add('col-xl-10');
        } else {
          eachClick=true;
          filterPanl.classList.remove('show');
          galView.classList.remove('col-xl-10');
        }
      });

      let filterClose = myDoc.querySelector('.filter-close');
      filterClose.addEventListener('click', (e) => {
        let filterPanl = myDoc.querySelector('.filter');
        let galView = myDoc.querySelector('.gallery-view');
        filterPanl.classList.remove('show');
        galView.classList.remove('col-xl-10');
        eachClick=true;
      });
    }

    //search
    // const searchOpen = () => {
    //   const search = myDoc.querySelector('.search-header');
    //   let formInput = search.querySelector('.form-control');

    //   // Create overlay div
    //   let divEle = myDoc.createElement('div');
    //   divEle.className = 'search-overlay';
    //   myDoc.body.appendChild(divEle);
    //   search.classList.add('active');
    //   formInput.focus();
    // };

    // function mobileSerachDilog(getLoc) {
    //   const searchBtn = myDoc.querySelectorAll('.iconSearch');
    //   Object.keys(searchBtn).forEach(function(key) {
    //       searchBtn[key].addEventListener('click', function(e) {
    //           e.preventDefault();
    //           getLoc();
    //           searchOpen();
    //           return false;
    //       });
    //   });
    // }


    myDoc.addEventListener('click', function(event) {
        let searchManHdr = myDoc.querySelector('.search-header');
        let searchBtn = myDoc.querySelector('.iconSearch');
        let getLocMdl = myDoc.querySelector('#getLocModal');

        if (searchManHdr && !searchManHdr.contains(event.target) && (searchBtn && !searchBtn.contains(event.target)) && (getLocMdl && !getLocMdl.contains(event.target))) {
            let divEle = myDoc.querySelector('.search-overlay');
            if (divEle) {
                myDoc.body.removeChild(divEle); // Remove overlay
            }
            searchManHdr.classList.remove('active'); // Deactivate search form
        }
    });



    function fetchLocation(){
      function getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              alert(
                `Location accessed: Latitude ${position.coords.latitude}, Longitude ${position.coords.longitude}`
              );
            },
            (error) => {
              if (error.code === error.PERMISSION_DENIED) {
                alert("Location access denied by the user.");
              } else {
                alert("Error accessing location: " + error.message);
              }
            }
          );
        } else {
          alert("Geolocation is not supported by this browser.");
        }
      }
      const allowButton = myDoc.querySelector(".btn-alaowLoc");
      const denyButton = myDoc.querySelector(".btn-regFtchLoc");
      const modalEl = document.querySelector('#getLocModal');
        if(modalEl){
            let getLocMdl =  new bootstrap.Modal(myDoc.querySelector('#getLocModal'), {});
            const getLocationMdlTgl = () =>{
                getLocMdl.toggle()
            }
        }

        if(allowButton){
            allowButton.onclick = () => {
                getLocation();
            };
        }

        if(denyButton){
            denyButton.onclick = () => {
                alert("You chose to deny location access.");
                getLocationMdlTgl();
            };
        }
      if(! mediaQ.matches){
        myDoc.querySelector("#search")?.addEventListener("click", getLocationMdlTgl);
      }else{
        //mobileSerachDilog(getLocationMdlTgl);
      }
    };
    fetchLocation();




    //search By KeyUp
    let searchByKeyUp = myDoc.querySelectorAll('.searchByKeyUp');
    //scalable search function
    function filterFunction(element, input) {
      var  filter, ul, li, a, i;
      filter = input.value.toUpperCase();
      //div = document.getElementById("filter_dorpdown_list");
      a = element.getElementsByTagName("a");
      for (i = 0; i < a.length; i++) {
          txtValue = a[i].textContent || a[i].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
              a[i].style.display = "";
          } else {
              a[i].style.display = "none";
          }
      }
    }

    if(searchByKeyUp){
      Object.keys(searchByKeyUp).forEach(ele => {
        let input = searchByKeyUp[ele].querySelector(".form-control");
        let itemWrap = searchByKeyUp[ele].querySelector(".model-search");
        //console.log(input, itemWrap) ;
        if(input){
          input.addEventListener('keyup', (e) => {
            filterFunction(itemWrap, e.target);
          });
        }
      })
    }


    //init favourite
    const tooltipTriggerList = myDoc.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = tooltipTriggerList?[...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl)):null;


    //favourite
    //** Initialize tooltip on favourite **/
    const favouriteBtn = myDoc.querySelector('.favourites-icon');
    if(favouriteBtn){
      const bsTooltip = bootstrap.Tooltip.getOrCreateInstance(favouriteBtn);
      favouriteBtn.addEventListener('click', () => {
        const newContent = favouriteBtn.getAttribute('data-bs-title') === 'Add to favourites!'? 'Remove from Favourites!' : 'Add to favourites!';
        favouriteBtn.setAttribute('data-bs-title', newContent);
        bsTooltip.setContent({ '.tooltip-inner': newContent });
      });
    }

    myDoc.addEventListener('click', function(event) {
        if (event.target.classList.contains('favourites-icon')) {
            event.target.classList.toggle('active');
            if (event.target.classList.contains('active')) {
                event.target.parentElement.querySelector('.favourites-message').textContent = 'Added to favourites!';
                // event.target.setAttribute('data-bs-title', 'Remove to favourite');
                // bsTooltip.setContent({ '.tooltip-inner': 'Remove to favourite' });
                //new bootstrap.Tooltip(favouriteBtn);
            } else {
                event.target.parentElement.querySelector('.favourites-message').textContent = 'Removed from Favourites!';
                // event.target.setAttribute('data-bs-title', 'Add to favourite');
                // bsTooltip.setContent({ '.tooltip-inner': 'Add to favourite' });
            }
            event.target.parentElement.querySelector('.favourites-message').classList.add('active');
            setTimeout(() => {
                event.target.parentElement.querySelector('.favourites-message').classList.remove('active');
            }, 1000);
        }
    });

    //new bootstrap.Tooltip(favouriteBtn);


    // myDoc.addEventListener('click', function(event) {
    //     if (event.target.classList.contains('favourites-message')) {
    //         event.target.classList.remove('active');
    //     }
    // });

    // myDoc.addEventListener('click', function(event) {
    //     if (!event.target.closest('.favourites')) {
    //         myDoc.querySelectorAll('.favourites-message').forEach(function(message) {
    //             message.classList.remove('active');
    //         });
    //     }
    // });


    // const formGroup = myDoc.querySelectorAll('.form-group');
    // if(formGroup) {
    //   Object.keys(formGroup).forEach(i =>{
    //     let lable = formGroup[i].querySelector('label');
    //     let input = formGroup[i].querySelector('.form-control');
    //     if(lable) {
    //       input.addEventListener('blur', (e)=>{
    //         if(e.target.value!==''){
    //           e.target.classList.add('hasVal');
    //         }else{
    //           e.target.classList.remove('hasVal');
    //         }
    //       })
    //     }
    //   })
    // }

    //input select dropdown selectted image needs to show on image tag
    const selectEscort = () => {
      let selectScContainer = myDoc.querySelectorAll('.select-escort');
      if(selectScContainer) {
        Object.keys(selectScContainer).forEach(i=>{
            let image = selectScContainer[i].querySelector('.booking-img');
            let input = selectScContainer[i].querySelector('.form-control');
            if(image) {
              let prevSec = image.src;
              input.addEventListener('change', (e) => {
                let img = e.target.options[e.target.selectedIndex].getAttribute('data-value');
                console.log(img);

                if(img) {
                  image.src = img;
                }else{
                  image.src = prevSec;
                  //console.log(prevSec);
                }
                //console.log(img);
              })
            }
        })
      }
    }
    selectEscort();


    //custom upload
    const inputFilewrap = myDoc.querySelectorAll('.inputFile');
    if (inputFilewrap) {
        Object.keys(inputFilewrap).forEach(function(key) {
            const fileInput = inputFilewrap[key].querySelector('[type="file"]');
            const uploadBtn = inputFilewrap[key].querySelector('.uploadBtn');
            const displayArea = inputFilewrap[key].querySelector('.form-control');
            const originalLabel = uploadBtn.textContent;

            fileInput.addEventListener('change', function() {
                const existingItems = displayArea.querySelectorAll('.file-item');
                existingItems.forEach(item => item.remove());
                if (this.files.length > 0) {
                    uploadBtn.textContent = this.files.length + ' file(s) selected';

                    for (let i = 0; i < this.files.length; i++) {
                        const fileWrapper = document.createElement('span');
                        fileWrapper.className = 'file-item d-flex align-items-center mb-1';

                        const fileNameSpan = document.createElement('span');
                        fileNameSpan.textContent = this.files[i].name;

                        const removeBtn = document.createElement('button');
                        removeBtn.type = 'button';
                        removeBtn.className = 'btn removeUploadFile ms-2 d-none';
                        removeBtn.innerHTML = '&times;';
                        removeBtn.dataset.index = i;

                        fileWrapper.appendChild(fileNameSpan);
                        fileWrapper.appendChild(removeBtn);
                        displayArea.appendChild(fileWrapper);
                    }
                } else {
                    uploadBtn.textContent = originalLabel;
                }
            });


            myDoc.addEventListener('click', function(e) {
                const removeBtn = e.target.querySelector('.removeUploadFile');
                //console.log(removeBtn);
                if (removeBtn) {
                    e.stopPropagation();
                    const fileName = removeBtn.previousElementSibling.textContent;
                    //console.log(fileName);
                    removeFileByName(fileName, fileInput);
                    removeBtn.closest('.file-item').remove();
                    uploadBtn.textContent = fileInput.files.length > 0
                        ? fileInput.files.length + ' file(s) selected'
                        : originalLabel;
                }
            });
        });
    }

    function removeFileByName(fileName, fileInput) {
        const files = Array.from(fileInput.files);
        const updatedFiles = files.filter(file => file.name !== fileName);

        const dataTransfer = new DataTransfer();
        updatedFiles.forEach(file => dataTransfer.items.add(file));

        fileInput.files = dataTransfer.files;
    }



    // myDoc.addEventListener("DOMContentLoaded", () => {
    //   const hasAccepted = localStorage.getItem("adultAccepted");
    //   const myModal = new bootstrap.Modal(myDoc.querySelector('#warningsModal'), {});
    //   const regBtn = myDoc.querySelector('.btn-adultReg');
    //   const acptBtn = myDoc.querySelector('.btn-acptEnter');
    //   if (hasAccepted !== "true") {
    //     myModal.toggle();
    //   }

    //   regBtn.addEventListener('click', ()=>{
    //     window.location.href = "https://google.com";
    //   });

    //   acptBtn.addEventListener('click', ()=>{
    //     localStorage.setItem("adultAccepted", "true");
    //     myModal.toggle();
    //   });

    // });


    // const hoverToFadeSlide = () => {
    //   const sliderWraper = myDoc.querySelectorAll('.hoverSlider');


    //     Object.keys(sliderWraper).forEach(i=>{
    //       let tmout;
    //       let sliderItems = sliderWraper[i].querySelectorAll('.media-holder picture');
    //       let sliderImg = [];
    //       let curentIndex = 0;
    //       let itrImg;
    //       function makeSlider() {
    //         sliderImg = [];
    //         Object.keys(sliderItems).forEach((imgEle)=>{
    //           // console.log(bannerItem[imgEle]);
    //           sliderImg.push(sliderItems[imgEle]);
    //         });

    //         itrImg = function () {
    //           for(let i=0; i<sliderImg.length; i++){
    //             sliderImg[i].style.display='none';
    //           }
    //         }

    //         itrImg();
    //         sliderImg[0].style.display='block ';

    //         function incrementSlider() {
    //           if(curentIndex!=sliderImg.length){
    //             sliderImg[curentIndex].style.display='block';
    //           }else{
    //             sliderImg[0].style.display='block'; curentIndex=0
    //           }
    //         }

    //         tmout=setInterval(function(){
    //           curentIndex++;
    //           itrImg();
    //           incrementSlider();
    //         }, 1000);
    //       }

    //       function stopSliding() {
    //         clearInterval(tmout);
    //         itrImg();
    //         sliderImg[0].style.display='block';
    //         curentIndex=0;
    //       }

    //       sliderWraper[i].addEventListener('mouseenter', makeSlider);
    //       sliderWraper[i].addEventListener('mouseleave', stopSliding);

    //     });
    // }
    // hoverToFadeSlide();

    // const hoverToFadeSlide = () => {
    //     const sliderWraper = myDoc.querySelectorAll('.hoverSlider');

    //     Object.keys(sliderWraper).forEach(i => {
    //         let tmout;
    //         let sliderItems = sliderWraper[i].querySelectorAll('.media-holder picture');
    //         let sliderImg = [];
    //         let curentIndex = 0;

    //         function makeSlider() {
    //             sliderImg = [];
    //             Object.keys(sliderItems).forEach((imgEle) => {
    //                 sliderImg.push(sliderItems[imgEle]);
    //                 sliderItems[imgEle].classList.remove('active');
    //             });

    //             // Show first image
    //             //sliderImg[0].classList.add('active');
    //             sliderImg[0].classList.remove('active');
    //             sliderImg[1]?.classList.add('active');
    //             //curentIndex = (curentIndex + 1) % sliderImg.length;
    //             tmout = setInterval(function() {
    //                 // Remove active class from current image
    //                 sliderImg[curentIndex].classList.remove('active');

    //                 // Increment index or reset to 0
    //                 curentIndex = (curentIndex + 1) % sliderImg.length;

    //                 // Add active class to new image
    //                 sliderImg[curentIndex].classList.add('active');
    //             }, 1500);
    //         }

    //         function stopSliding() {
    //         clearInterval(tmout);

    //         // Remove active from all images except first
    //         sliderImg.forEach((img, index) => {
    //             img.classList.remove('active');
    //             if (index === 0) {
    //                 img.classList.add('active');
    //             }
    //         });

    //         curentIndex = 0;
    //         }

    //         sliderWraper[i].addEventListener('mouseenter', makeSlider);
    //         sliderWraper[i].addEventListener('mouseleave', stopSliding);
    //     });
    // }

    // hoverToFadeSlide();

    document.addEventListener('mouseover', function(e) {
        const sliderWrapper = e.target.closest('.hoverSlider');
        if (!sliderWrapper) return;

        // Check if we've already set up listeners for this wrapper
        if (sliderWrapper.dataset.sliderInitialized) return;
        sliderWrapper.dataset.sliderInitialized = 'true';

        let tmout;
        let curentIndex = 0;

        function makeSlider() {
            const sliderItems = sliderWrapper.querySelectorAll('.media-holder .media-holder-img');
            const sliderImg = Array.from(sliderItems);

            if (sliderImg.length < 2) return;

            sliderImg.forEach(img => img.classList.remove('active'));
            sliderImg[0].classList.remove('active');
            sliderImg[1]?.classList.add('active');

            clearInterval(tmout);
            tmout = setInterval(function() {
                sliderImg[curentIndex].classList.remove('active');
                curentIndex = (curentIndex + 1) % sliderImg.length;
                sliderImg[curentIndex].classList.add('active');
            }, 1500);
        }

        function stopSliding() {
            clearInterval(tmout);
            const sliderImg = sliderWrapper.querySelectorAll('.media-holder .media-holder-img');
            sliderImg.forEach((img, index) => {
                img.classList.remove('active');
                if (index === 0) img.classList.add('active');
            });
            curentIndex = 0;
        }

        sliderWrapper.addEventListener('mouseenter', makeSlider);
        sliderWrapper.addEventListener('mouseleave', stopSliding);

        // Trigger initial setup
        makeSlider();
    });


    const loadMoreServices = () => {
        const loadMoreBtn = document.querySelector('#loadMoreServices');
        const serviceItems = document.querySelectorAll('.service-item');
        let currentVisible = 9;
        const loadCount = 6;

        loadMoreBtn?.addEventListener('click', () => {
            loadMoreBtn.classList.add('loading');
            for (let i = currentVisible; i < currentVisible + loadCount && i < serviceItems.length; i++) {
                setTimeout(() => {
                    loadMoreBtn.classList.remove('loading');
                    serviceItems[i].classList.remove('d-none');
                }, 1000);
                //serviceItems[i].classList.remove('d-none');
            }
            currentVisible += loadCount;
            console.log(currentVisible);

            if (currentVisible >= serviceItems.length) {
                loadMoreBtn.style.display = 'none';
            }
        });
    }

    loadMoreServices();

    let rattingIBtn = document.querySelectorAll('.gallery-single-infoWrap-rating');
    rattingIBtn.forEach((item) => {
        item.addEventListener('click', () => {
            const collapseElement = document.getElementById(`${item.getAttribute('data-target')}`);
            if (!collapseElement) {
                console.error("Could not find collapseFive element");
                return;
            }

            const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseElement);
            bsCollapse.show();


            function scrollHandler() {
                setTimeout(() => {
                    const targetElement = collapseElement.closest('.rettingItem');
                    console.log(targetElement.getBoundingClientRect().top);
                    if (targetElement) {
                        // Option 1: Precise calculation
                        const yOffset = -100; // Adjust this value
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: y,
                            behavior: 'smooth'
                        });

                        // Option 2: scrollIntoView with options
                        // targetElement.scrollIntoView({
                        //     behavior: 'smooth',
                        //     block: 'start'
                        // });
                    }
                    //collapseElement.removeEventListener('shown.bs.collapse', scrollHandler);
                }, 500);
            }
            scrollHandler();
            collapseElement.addEventListener('shown.bs.collapse', scrollHandler);
        })
    })


    document.addEventListener('DOMContentLoaded', () => {
      function createVideo(url) {
        const video = document.createElement("video");
        video.src = url;
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.style.width = "100%";
        video.style.zIndex = "12";
        return video;
      }

      function handlePlay(card) {
        const holder = card.querySelector(".galvideo");
        const url = holder.dataset.video;
         if (!url) return;
        if (!holder.querySelector("video")) {
          const video = createVideo(url);
          holder.appendChild(video);
        }
      }

      function handleStop(card) {
        const video = card.querySelector("video");
        if (video) {
          video.pause();
          video.remove();
        }
      }
      const galleryContainer = document.body;
      if (isMobile) {
        galleryContainer.addEventListener("click", (e) => {
          const card = e.target.closest(".card-staff-video");
          if (!card) return;
          e.preventDefault();
          if (card.querySelector("video")) {
            handleStop(card);
          } else {
            handlePlay(card);
          }
          const otherCards = document.querySelectorAll(".card-staff-video");
          otherCards.forEach((otherCard) => {
            if (otherCard !== card) {
              otherCard.querySelector("video")?.remove();
            }
          });
        });
      } else {
        galleryContainer.addEventListener("mouseenter", (e) => {
          const card = e.target.closest(".card-staff-video");
          if (card) handlePlay(card);
        }, true);

        galleryContainer.addEventListener("mouseleave", (e) => {
          const card = e.target.closest(".card-staff-video");
          if (card) handleStop(card);
        }, true);
      }

    });

// Initialize the global cursor
// const cursor = document.querySelector('.global-custom-cursor');
// console.log(cursor);
// // Mouse move handler (position updates)
// document.addEventListener('mousemove', (e) => {
//   cursor.style.left = `${e.clientX}px`;
//   cursor.style.top = `${e.clientY}px`;
// });

// // Event delegation for hover effects
// document.body.addEventListener('mouseover', (e) => {
//     const staffCard = e.target.closest('.card-staff');
//     const naviAtag = e.target.closest('.nav-min-menu a') ||
//                     e.target.closest('footer a') ||
//                     e.target.closest('.price') ||
//                     e.target.closest('.age') ||
//                     e.target.closest('.custom-check__label') ||
//                     e.target.closest('.form-switch') ||
//                     e.target.closest('.clear_filter');
//     const btnContact = e.target.closest('.btn-contact') ||
//                         e.target.closest('.header-min-account') ||
//                         e.target.closest('.favourites ');
//     if (staffCard) {
//         //const isAvailable = staffCard.querySelector('.availability').classList.contains('available');
//         //cursor.textContent = isAvailable ? 'Available' : 'Away';
//         //cursor.className = `global-custom-cursor ${isAvailable ? 'available' : 'away'}`;
//         //cursor.style.opacity = '1';
//         //cursor.style.cssText = 'width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; opacity: 1;';
//         cursor.style.cssText = 'width: 20px; height: 20px; opacity: 0.5; filter: blur(10px);';
//     }else if (naviAtag) {
//         cursor.style.cssText = 'width: 20px; height: 20px; opacity: 0.5; filter: blur(10px);';
//     }else if (btnContact) {
//         cursor.style.cssText = 'width: 40px; height: 40px; opacity: 0.5; filter: blur(10px);';
//     }
// });

// document.body.addEventListener('mouseout', (e) => {
//     if (!e.relatedTarget || !e.relatedTarget.closest('.card-staff')) {
//         //cursor.style.opacity  = '0.75';
//         cursor.style.cssText = 'width: auto; height: auto; display: flex; align-items: center; justify-content: center; opacity: 0.3;';
//         cursor.textContent = '';
//         cursor.className = 'global-custom-cursor';
//     }
// });

// // Optional: MutationObserver for dynamically loaded content
// const observer = new MutationObserver((mutations) => {
//     // Check if new staff cards were added
//     const addedNodes = mutations.flatMap(m => [...m.addedNodes]);
//     if (addedNodes.some(node => node.classList?.contains('card-staff'))) {
//         // No need to re-bind events thanks to delegation
//     }
// });

// observer.observe(document.body, {
//     childList: true,
//     subtree: true
// });

})(document);

// Gallery filter & sorting bar (moved from partials/filter_and_sorting/staff-sorting.blade.php)
// Gallery filter option lists (areas, services, types and their hidden backing
// checkboxes) ship inside <template class="fbar-lazy"> to keep ~700 elements out of
// the initial DOM. Insert them on first interaction with the filters, or straight
// away when the URL already carries filters (filter.js restores state from them).
(function () {
    window.hydrateGalleryFilters = function () {
        if (document.querySelector('[data-gallery-options]')) {
            return window.loadGalleryFilterOptions?.() || Promise.resolve();
        }
        var templates = document.querySelectorAll('template.fbar-lazy');
        if (!templates.length) return false;
        templates.forEach(function (t) { t.replaceWith(t.content.cloneNode(true)); });
        document.dispatchEvent(new CustomEvent('gallery:filters-hydrated'));
        return true;
    };
    if (document.querySelector('[data-gallery-options]') || !document.querySelector('template.fbar-lazy')) return;

    var filterKeys = ['sort', 'borough', 'prices', 'ages', 'busts', 'nationality', 'hair_colour',
        'fetishes', 'toys', 'all_fetishes', 'services', 'location_call_mode', 'incall_location',
        'category', 'dresses', 'available'];
    var params = new URLSearchParams(window.location.search);
    if (filterKeys.some(function (key) { return params.get(key); })) {
        window.hydrateGalleryFilters();
        return;
    }
    var zone = '.gallery-list, .all-escorts-sidebar, .fbar-filters-wrap, #fbarDrawer, .smart-gallery-filter';
    // Discrete input only: layout shifts right after a click/tap/key are exempt from CLS,
    // whereas a hover-triggered insert would count as a shift. pointerdown precedes the
    // click that opens a dropdown, so the options are already there when it opens.
    var events = ['pointerdown', 'focusin', 'touchstart'];
    function onIntent(event) {
        if (!event.target.closest || !event.target.closest(zone)) return;
        events.forEach(function (name) { document.removeEventListener(name, onIntent, true); });
        window.hydrateGalleryFilters();
    }
    events.forEach(function (name) { document.addEventListener(name, onIntent, { capture: true, passive: true }); });
})();

(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var sortBtn   = document.querySelector('.gallery-list-dropdown > a');
        var sortLabel = sortBtn ? sortBtn.querySelector('.fbar-sort-label') : null;
        var defaultLabel = 'Sort by';

        // filter.js attaches its own change listeners to input[name="sortby"] at init time.
        // We just piggyback on the same change event to update our button label.
        document.querySelectorAll('input[name="sortby"]').forEach(function (radio) {
            radio.addEventListener('change', function () {
                if (sortLabel) {
                    // Get text from the associated <label for="...">
                    var lbl = document.querySelector('label[for="' + radio.id + '"]');
                    sortLabel.textContent = lbl ? lbl.textContent.trim() : defaultLabel;
                }
                if (sortBtn) sortBtn.classList.add('fbar-active');
                // Bootstrap closes the dropdown automatically (default auto-close on label click)
            });
        });

        // When the Sort by dropdown closes, Bootstrap restores focus to the toggle
        // button via element.focus() which causes the browser to scroll to it if it
        // is off-screen (e.g. user scrolled up). Re-focus with preventScroll so the
        // page position is not disturbed.
        var sortDropdownEl = sortBtn ? sortBtn.closest('.gallery-list-dropdown') : null;
        if (sortDropdownEl) {
            sortDropdownEl.addEventListener('hidden.bs.dropdown', function () {
                if (sortBtn) sortBtn.focus({ preventScroll: true });
            });
        }

        // Clear sort button — reset everything
        var clearBtn = document.querySelector('.clear-sorting-btn');
        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                document.querySelectorAll('input[name="sortby"]').forEach(function (r) { r.checked = false; });
                if (sortLabel) sortLabel.textContent = defaultLabel;
                if (sortBtn)   sortBtn.classList.remove('fbar-active');
            });
        }

        /* ── Feature filters: Incall location + Services ── */

        // Generic: filter visible items in a list by the mini-search box.
        // Delegated: the lists may be inserted after this runs (see hydrateGalleryFilters).
        document.addEventListener('input', function (event) {
            var box = event.target;
            if (!box.matches || !box.matches('.fbar-mini-input')) return;
            var list = document.querySelector(box.dataset.target);
            if (!list) return;
            var term = box.value.trim().toLowerCase();
            var visible = 0;
            list.querySelectorAll('.fbar-check-item').forEach(function (item) {
                var match = !term || (item.dataset.search || '').indexOf(term) !== -1;
                item.classList.toggle('d-none', !match);
                if (match) visible++;
            });
            var empty = list.parentNode.querySelector('.fbar-empty');
            if (empty) empty.classList.toggle('d-none', visible !== 0);
        });

        var sidebarReset = document.querySelector('.all-escorts-sidebar__reset');
        function refreshSidebarReset() {
            if (!sidebarReset) return;
            var hasActiveFilters = !!document.querySelector(
                '.fbar-feature-btn .fbar-count-badge:not(.d-none):not(.fbar-filters-count), .filter-list input:checked, input.available:checked'
            );
            sidebarReset.classList.toggle('d-none', !hasActiveFilters);
        }

        // Update a feature button's badge / active state from a count.
        function setFeatureButton(btn, countEl, clearBlock, n) {
            if (countEl) {
                countEl.textContent = n;
                countEl.classList.toggle('d-none', n === 0);
            }
            if (btn) btn.classList.toggle('fbar-active', n > 0);
            if (clearBlock) clearBlock.classList.toggle('d-none', n === 0);
            refreshSidebarReset();
        }

        // ── Incall location (canonical checkboxes; filter.js does the fetch) ──
        var locBtn       = document.querySelector('.fbar-feature .fbar-loc-label')
                            ? document.querySelector('.fbar-loc-label').closest('.fbar-feature-btn') : null;
        var locCount     = document.querySelector('.fbar-loc-count');
        var locClearBlock= document.querySelector('.fbar-loc-clear') ? document.querySelector('.fbar-loc-clear').closest('.fbar-clear-block') : null;
        // Option lists can be inserted late, so look them up live and delegate events.
        function locInputs() { return document.querySelectorAll('.incall-location'); }

        function refreshLocationButton() {
            var n = 0;
            locInputs().forEach(function (i) { if (i.checked) n++; });
            setFeatureButton(locBtn, locCount, locClearBlock, n);
        }
        document.addEventListener('change', function (event) {
            if (event.target.matches && event.target.matches('.incall-location')) refreshLocationButton();
        });
        refreshLocationButton();
        var locClear = document.querySelector('.fbar-loc-clear');
        if (locClear) {
            locClear.addEventListener('click', function () {
                var inputs = locInputs();
                var changed = false;
                inputs.forEach(function (i) { if (i.checked) { i.checked = false; changed = true; } });
                refreshLocationButton();
                // Trigger filter.js to recompute + refetch (it listens for 'input').
                if (changed && inputs.length) {
                    inputs[0].dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }

        // ── Services (proxy to the offcanvas .service checkboxes) ──
        var svcBtn        = document.querySelector('.fbar-svc-label') ? document.querySelector('.fbar-svc-label').closest('.fbar-feature-btn') : null;
        var svcCount      = document.querySelector('.fbar-svc-count');
        var svcClearBlock = document.querySelector('.fbar-svc-clear') ? document.querySelector('.fbar-svc-clear').closest('.fbar-clear-block') : null;
        function svcProxies() { return document.querySelectorAll('.fbar-svc-proxy'); }

        function offcanvasServiceInput(id) {
            return document.querySelector('input.service[value="' + id + '"]');
        }
        function refreshServicesButton() {
            var n = 0;
            svcProxies().forEach(function (p) {
                var src = offcanvasServiceInput(p.dataset.serviceId);
                var on = !!(src && src.checked);
                p.classList.toggle('fbar-active-row', on);
                if (on) n++;
            });
            setFeatureButton(svcBtn, svcCount, svcClearBlock, n);
        }
        document.addEventListener('click', function (event) {
            var proxy = event.target.closest && event.target.closest('.fbar-svc-proxy');
            if (!proxy) return;
            var src = offcanvasServiceInput(proxy.dataset.serviceId);
            if (!src) return;
            src.checked = !src.checked;
            src.dispatchEvent(new Event('input', { bubbles: true }));
            refreshServicesButton();
        });
        refreshServicesButton();
        var svcClear = document.querySelector('.fbar-svc-clear');
        if (svcClear) {
            svcClear.addEventListener('click', function () {
                var changed = false, last = null;
                svcProxies().forEach(function (p) {
                    var src = offcanvasServiceInput(p.dataset.serviceId);
                    if (src && src.checked) { src.checked = false; changed = true; last = src; }
                });
                refreshServicesButton();
                if (changed && last) last.dispatchEvent(new Event('input', { bubbles: true }));
            });
        }

        // ── Type / categories (proxy to the offcanvas .category checkboxes) ──
        var catBtn        = document.querySelector('.fbar-cat-label') ? document.querySelector('.fbar-cat-label').closest('.fbar-feature-btn') : null;
        var catCount      = document.querySelector('.fbar-cat-count');
        var catClearBlock = document.querySelector('.fbar-cat-clear') ? document.querySelector('.fbar-cat-clear').closest('.fbar-clear-block') : null;
        function catProxies() { return document.querySelectorAll('.fbar-cat-proxy'); }

        function offcanvasCategoryInput(id) {
            return document.querySelector('input.category[value="' + id + '"]');
        }
        function refreshCategoriesButton() {
            var n = 0;
            catProxies().forEach(function (p) {
                var src = offcanvasCategoryInput(p.dataset.categoryId);
                var on = !!(src && src.checked);
                p.classList.toggle('fbar-active-row', on);
                if (on) n++;
            });
            setFeatureButton(catBtn, catCount, catClearBlock, n);
        }
        document.addEventListener('click', function (event) {
            var proxy = event.target.closest && event.target.closest('.fbar-cat-proxy');
            if (!proxy) return;
            var src = offcanvasCategoryInput(proxy.dataset.categoryId);
            if (!src) return;
            src.checked = !src.checked;
            src.dispatchEvent(new Event('input', { bubbles: true }));
            refreshCategoriesButton();
        });
        refreshCategoriesButton();
        var catClear = document.querySelector('.fbar-cat-clear');
        if (catClear) {
            catClear.addEventListener('click', function () {
                var changed = false, last = null;
                catProxies().forEach(function (p) {
                    var src = offcanvasCategoryInput(p.dataset.categoryId);
                    if (src && src.checked) { src.checked = false; changed = true; last = src; }
                });
                refreshCategoriesButton();
                if (changed && last) last.dispatchEvent(new Event('input', { bubbles: true }));
            });
        }

        // ── Bust size (direct checkboxes inside the dropdown) ──
        var bustBtn        = document.querySelector('.fbar-bust-label') ? document.querySelector('.fbar-bust-label').closest('.fbar-feature-btn') : null;
        var bustCount      = document.querySelector('.fbar-bust-count');
        var bustClearBlock = document.querySelector('.fbar-bust-clear') ? document.querySelector('.fbar-bust-clear').closest('.fbar-clear-block') : null;
        var bustInputs     = bustBtn ? bustBtn.closest('.fbar-feature').querySelectorAll('input.bust') : [];
        var bustCatProxies = document.querySelectorAll('.fbar-bustcat-proxy');

        function refreshBustButton() {
            var n = 0;
            bustInputs.forEach(function (i) { if (i.checked) n++; });
            // Natural / Enhanced rows mirror the hidden category checkboxes
            bustCatProxies.forEach(function (p) {
                var src = offcanvasCategoryInput(p.dataset.categoryId);
                var on = !!(src && src.checked);
                p.classList.toggle('fbar-active-row', on);
                if (on) n++;
            });
            setFeatureButton(bustBtn, bustCount, bustClearBlock, n);
        }
        bustInputs.forEach(function (input) {
            input.addEventListener('change', refreshBustButton);
        });
        bustCatProxies.forEach(function (proxy) {
            proxy.addEventListener('click', function () {
                var src = offcanvasCategoryInput(proxy.dataset.categoryId);
                if (!src) return;
                src.checked = !src.checked;
                src.dispatchEvent(new Event('input', { bubbles: true }));
                refreshBustButton();
                if (typeof refreshCategoriesButton === 'function') refreshCategoriesButton();
            });
        });
        var bustClear = document.querySelector('.fbar-bust-clear');
        if (bustClear) {
            bustClear.addEventListener('click', function () {
                var changed = false, last = null;
                bustInputs.forEach(function (i) {
                    if (i.checked) { i.checked = false; changed = true; last = i; }
                });
                bustCatProxies.forEach(function (p) {
                    var src = offcanvasCategoryInput(p.dataset.categoryId);
                    if (src && src.checked) { src.checked = false; changed = true; last = src; }
                });
                refreshBustButton();
                if (changed && last) last.dispatchEvent(new Event('input', { bubbles: true }));
            });
        }

        // ── Dominatrix intensity (direct CMS fetish checkboxes) ──
        var dominationBtn = document.querySelector('.fbar-domination-label') ? document.querySelector('.fbar-domination-label').closest('.fbar-feature-btn') : null;
        var dominationCount = document.querySelector('.fbar-domination-count');
        var dominationClearBlock = document.querySelector('.fbar-domination-clear') ? document.querySelector('.fbar-domination-clear').closest('.fbar-clear-block') : null;
        var dominationInputs = dominationBtn ? dominationBtn.closest('.fbar-feature').querySelectorAll('input.fetish') : [];

        function refreshDominationButton() {
            var n = 0;
            dominationInputs.forEach(function (input) { if (input.checked) n++; });
            setFeatureButton(dominationBtn, dominationCount, dominationClearBlock, n);
        }
        dominationInputs.forEach(function (input) {
            input.addEventListener('change', refreshDominationButton);
        });
        var dominationClear = document.querySelector('.fbar-domination-clear');
        if (dominationClear) {
            dominationClear.addEventListener('click', function () {
                var changed = false;
                dominationInputs.forEach(function (input) {
                    if (input.checked) { input.checked = false; changed = true; }
                });
                refreshDominationButton();
                if (changed && dominationInputs.length) {
                    dominationInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
        refreshDominationButton();

        function wireDirectRelationFilter(key, inputSelector) {
            var label = document.querySelector('.fbar-' + key + '-label');
            var btn = label ? label.closest('.fbar-feature-btn') : null;
            var count = document.querySelector('.fbar-' + key + '-count');
            var clear = document.querySelector('.fbar-' + key + '-clear');
            var clearBlock = clear ? clear.closest('.fbar-clear-block') : null;
            var inputs = btn ? btn.closest('.fbar-feature').querySelectorAll(inputSelector) : [];
            function refresh() {
                var n = 0;
                inputs.forEach(function (input) { if (input.checked) n++; });
                setFeatureButton(btn, count, clearBlock, n);
            }
            inputs.forEach(function (input) { input.addEventListener('change', refresh); });
            if (clear) {
                clear.addEventListener('click', function () {
                    var changed = false;
                    inputs.forEach(function (input) {
                        if (input.checked) { input.checked = false; changed = true; }
                    });
                    refresh();
                    if (changed && inputs.length) inputs[0].dispatchEvent(new Event('input', { bubbles: true }));
                });
            }
            refresh();
        }
        wireDirectRelationFilter('toys', 'input.toy');
        wireDirectRelationFilter('fetishes', 'input.fetish-all');

        var routeAge = document.querySelector('.fbar-age-feature');
        if (routeAge) {
            var ageFrom = routeAge.querySelector('.fbar-age-from');
            var ageTo = routeAge.querySelector('.fbar-age-to');
            var ageInputs = routeAge.querySelectorAll('.fbar-route-age');
            var ageBtn = routeAge.querySelector('.fbar-feature-btn');
            var ageCount = routeAge.querySelector('.fbar-age-count');
            var ageClear = routeAge.querySelector('.fbar-age-clear');
            var ageClearBlock = ageClear ? ageClear.closest('.fbar-clear-block') : null;
            var defaultMin = Number(routeAge.dataset.ageMin);
            var defaultMax = Number(routeAge.dataset.ageMax);
            var openEnded = routeAge.dataset.openEnded === '1';
            function refreshRouteAge(trigger) {
                if (Number(ageFrom.value) > Number(ageTo.value)) {
                    if (trigger === ageFrom) ageTo.value = ageFrom.value;
                    else ageFrom.value = ageTo.value;
                }
                ageInputs[0].value = ageFrom.value;
                ageInputs[1].value = openEnded && Number(ageTo.value) === defaultMax ? 99 : ageTo.value;
                var active = Number(ageFrom.value) !== defaultMin || Number(ageTo.value) !== defaultMax;
                setFeatureButton(ageBtn, ageCount, ageClearBlock, active ? 1 : 0);
                if (trigger) ageInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
            }
            ageFrom.addEventListener('change', function () { refreshRouteAge(ageFrom); });
            ageTo.addEventListener('change', function () { refreshRouteAge(ageTo); });
            if (ageClear) ageClear.addEventListener('click', function () {
                ageFrom.value = defaultMin;
                ageTo.value = defaultMax;
                refreshRouteAge(ageFrom);
            });
            document.querySelectorAll('.clear_filter').forEach(function (resetButton) {
                resetButton.addEventListener('click', function () {
                    ageFrom.value = defaultMin;
                    ageTo.value = defaultMax;
                    refreshRouteAge(null);
                });
            });
            refreshRouteAge(null);
        }

        // Keep the proxy buttons in sync whenever a feature dropdown opens
        // (services/types can also be toggled from the offcanvas "Filters" panel).
        document.querySelectorAll('.fbar-feature').forEach(function (dd) {
            dd.addEventListener('show.bs.dropdown', function () {
                refreshServicesButton();
                refreshCategoriesButton();
                refreshBustButton();
            });
        });

        // The offcanvas "Clear all" unchecks every checkbox + refetches — resync our buttons.
        var clearAll = document.querySelector('.clear_filter');
        document.querySelectorAll('.clear_filter').forEach(function (resetButton) {
            resetButton.addEventListener('click', function () {
                setTimeout(function () {
                    refreshLocationButton();
                    refreshServicesButton();
                    refreshCategoriesButton();
                    refreshBustButton();
                    refreshSidebarReset();
                }, 0);
            });
        });

        // Initial sync (in case of restored state)
        refreshLocationButton();
        refreshServicesButton();
        refreshCategoriesButton();
        refreshBustButton();
        refreshSidebarReset();
        document.addEventListener('gallery:filters-hydrated', function () {
            refreshLocationButton();
            refreshServicesButton();
            refreshCategoriesButton();
            refreshBustButton();
            refreshSidebarReset();
        });

        // Busty is the route-defining gallery, so put its most relevant
        // refinement first on both the desktop sidebar and mobile drawer.
        var bustFeature = bustBtn ? bustBtn.closest('.fbar-feature') : null;
        var featureRow = bustFeature ? bustFeature.closest('.fbar-viewrow') : null;
        var firstFeature = featureRow ? featureRow.querySelector('.fbar-dropdown.fbar-feature') : null;
        if (bustFeature && firstFeature && bustFeature !== firstFeature) {
            featureRow.insertBefore(bustFeature, firstFeature);
        }

        // ── Mobile slide-out filter drawer ──
        // On phones, physically move the feature filter pills (Type/Services/
        // Incall/Bust) into the drawer and turn each into an accordion section.
        // Element listeners travel with the nodes, so all filter logic keeps working.
        (function () {
            var drawer = document.getElementById('fbarDrawer');
            var filtersWrap = document.querySelector('.fbar-filters-wrap');
            if (!drawer || !filtersWrap) return;
            var features = Array.prototype.slice.call(
                document.querySelectorAll('.fbar-viewrow .fbar-dropdown.fbar-feature')
            );
            if (!features.length) {
                // Nothing to filter — hide the button entirely.
                filtersWrap.classList.add('d-none');
                return;
            }
            var body = drawer.querySelector('.fbar-drawer-body');
            var filtersBtn = filtersWrap.querySelector('.fbar-filters-btn');
            var smartFilter = document.querySelector('.smart-gallery-filter');
            // Keep the fixed drawer outside the sticky gallery toolbar. Once the
            // toolbar compacts, its backdrop-filter creates a containing block
            // that would otherwise constrain this drawer to the toolbar height.
            document.body.appendChild(drawer);
            var smartFilterHome = smartFilter ? {
                parent: smartFilter.parentNode,
                next: smartFilter.nextSibling
            } : null;
            // Remember each pill's original slot so we can move it back on resize.
            var homes = features.map(function (dd) {
                return { parent: dd.parentNode, next: dd.nextSibling };
            });
            features.forEach(function (dd) {
                var toggle = dd.querySelector('[data-bs-toggle="dropdown"], .fbar-feature-btn');
                if (!toggle) return;
                dd._fbarToggle = toggle;
                toggle.addEventListener('click', function (e) {
                    // Accordion behaviour only while the pill lives inside the drawer;
                    // on desktop we return early so Bootstrap's dropdown handles it.
                    if (!dd.closest('#fbarDrawer')) return;
                    e.preventDefault();
                    e.stopPropagation();
                    var wasOpen = dd.classList.contains('open');
                    // One section open at a time
                    body.querySelectorAll('.fbar-dropdown.open').forEach(function (o) { o.classList.remove('open'); });
                    dd.classList.toggle('open', !wasOpen);
                    if (!wasOpen) {
                        refreshServicesButton();
                        refreshCategoriesButton();
                        refreshBustButton();
                    }
                });
            });

            var openDrawer = function () {
                drawer.classList.add('show');
                drawer.setAttribute('aria-hidden', 'false');
                document.body.classList.add('fbar-drawer-open');
                if (filtersBtn) filtersBtn.setAttribute('aria-expanded', 'true');
                refreshServicesButton();
                refreshCategoriesButton();
                refreshBustButton();
                var closeBtn = drawer.querySelector('.fbar-drawer-close');
                if (closeBtn) closeBtn.focus();
            };
            var closeDrawer = function () {
                var hadFocus = drawer.contains(document.activeElement);
                drawer.classList.remove('show');
                drawer.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('fbar-drawer-open');
                if (filtersBtn) {
                    filtersBtn.setAttribute('aria-expanded', 'false');
                    if (hadFocus) filtersBtn.focus();
                }
            };

            function enterMobile() {
                features.forEach(function (dd) {
                    var t = dd._fbarToggle;
                    if (t) {
                        if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                            try { var inst = bootstrap.Dropdown.getInstance(t); if (inst) inst.dispose(); } catch (e) {}
                        }
                        t.removeAttribute('data-bs-toggle');
                    }
                    body.appendChild(dd);
                });
            }
            function leaveMobile() {
                closeDrawer();
                features.forEach(function (dd, i) {
                    dd.classList.remove('open');
                    var t = dd._fbarToggle;
                    if (t) t.setAttribute('data-bs-toggle', 'dropdown');
                    var h = homes[i];
                    h.parent.insertBefore(dd, h.next);
                });
            }
            // All Escorts also uses this shared drawer inside its map overlay at
            // tablet widths, where three side-by-side panes would be too tight.
            var mq = window.matchMedia(document.getElementById('allEscortsMapOverlay')
                ? '(max-width: 991px)'
                : '(max-width: 767px)');
            if (mq.matches) enterMobile();
            var onBreakpoint = function (m) { m.matches ? enterMobile() : leaveMobile(); };
            if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
            else if (mq.addListener) mq.addListener(onBreakpoint);

            var smartMq = window.matchMedia('(max-width: 767px)');
            var placeSmartFilter = function (mobile) {
                if (!smartFilter || !smartFilterHome) return;
                if (mobile) {
                    smartFilter.classList.add('smart-gallery-filter--drawer');
                    body.insertBefore(smartFilter, body.firstChild);
                } else {
                    smartFilter.classList.remove('smart-gallery-filter--drawer');
                    smartFilterHome.parent.insertBefore(smartFilter, smartFilterHome.next);
                }
            };
            placeSmartFilter(smartMq.matches);
            var onSmartBreakpoint = function (m) { placeSmartFilter(m.matches); };
            if (smartMq.addEventListener) smartMq.addEventListener('change', onSmartBreakpoint);
            else if (smartMq.addListener) smartMq.addListener(onSmartBreakpoint);

            if (filtersBtn) filtersBtn.addEventListener('click', openDrawer);
            drawer.addEventListener('click', function (event) {
                if (event.target.closest('.fbar-drawer-backdrop, .fbar-drawer-close, .fbar-drawer-done')) {
                    closeDrawer();
                }
            });

            // Reset all visitor-selected filters in one pass. The shared sidebar
            // Reset owns the canonical state and performs exactly one refetch;
            // fixed route context is reapplied by filter.js.
            var resetBtn = drawer.querySelector('.fbar-drawer-reset');
            if (resetBtn) {
                resetBtn.addEventListener('click', function () {
                    if (clearAll) clearAll.click();
                    // Collapse all accordion sections
                    body.querySelectorAll('.fbar-dropdown.open').forEach(function (o) { o.classList.remove('open'); });
                });
            }
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && drawer.classList.contains('show')) closeDrawer();
            });

            // Active-filter count badge on the Filters button
            var filtersCount = filtersWrap.querySelector('.fbar-filters-count');
            var refreshFiltersBadge = function () {
                var n = document.querySelectorAll('.filter-list input:checked, input.bust:checked').length;
                if (filtersCount) {
                    filtersCount.textContent = n;
                    filtersCount.classList.toggle('d-none', n === 0);
                }
                if (filtersBtn) filtersBtn.classList.toggle('fbar-active', n > 0);
            };
            document.addEventListener('input', function (e) {
                if (e.target && e.target.matches && e.target.matches('input[type="checkbox"]')) refreshFiltersBadge();
            }, true);
            drawer.addEventListener('click', function () { setTimeout(refreshFiltersBadge, 0); });
            document.querySelectorAll('.clear_filter').forEach(function (resetButton) {
                resetButton.addEventListener('click', function () {
                    setTimeout(refreshFiltersBadge, 0);
                });
            });
            refreshFiltersBadge();
        })();

    });
})();


/* Page FAQ accordion toggle (migrated from partials/faqs.blade.php) */
(function(){
    document.querySelectorAll('.page-faqs .faq-q').forEach(function(btn){
        btn.addEventListener('click', function(){
            var expanded = btn.getAttribute('aria-expanded') === 'true';
            var homeFaqs = btn.closest('.home-page-faqs');
            if (homeFaqs && !expanded) {
                homeFaqs.querySelectorAll('.faq-q[aria-expanded="true"]').forEach(function(openBtn){
                    if (openBtn === btn) return;
                    openBtn.setAttribute('aria-expanded', 'false');
                    var openPanel = document.getElementById(openBtn.getAttribute('aria-controls'));
                    if (openPanel) openPanel.style.maxHeight = null;
                });
            }
            btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            var panel = document.getElementById(btn.getAttribute('aria-controls'));
            if(!panel) return;
            panel.style.maxHeight = expanded ? null : (panel.scrollHeight + 'px');
        });
    });
})();

/* Progressive enhancement for the server-rendered editorial guide.
   All original headings and content remain readable without JavaScript. */
(function(){
    document.querySelectorAll('[data-editorial-guide]').forEach(function(guide){
        var entries = Array.from(guide.querySelectorAll('[data-editorial-link]')).map(function(link){
            return { link: link, section: document.getElementById(link.hash.slice(1)) };
        }).filter(function(entry){ return entry.section; });
        if (!entries.length) return;
        var frame = null;
        var mobileViewport = window.matchMedia('(max-width: 767.98px)');

        entries.forEach(function(entry){
            var heading = entry.section.querySelector(':scope > h2');
            if (!heading) return;

            var body = document.createElement('div');
            body.className = 'editorial-guide__section-body';
            body.id = entry.section.id + '-body';
            while (heading.nextSibling) body.appendChild(heading.nextSibling);

            var header = document.createElement('div');
            header.className = 'editorial-guide__section-head';
            if (!heading.querySelector('a, button, input, select, textarea')) {
                header.classList.add('editorial-guide__section-head--clickable');
            }
            entry.section.insertBefore(header, heading);
            header.appendChild(heading);

            var toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'editorial-guide__toggle';
            toggle.setAttribute('aria-controls', body.id);
            header.appendChild(toggle);
            entry.section.appendChild(body);

            entry.mobileBody = body;
            entry.mobileToggle = toggle;
            entry.headingText = heading.textContent.trim();
            entry.mobileOpen = false;
            toggle.addEventListener('click', function(){
                if (!mobileViewport.matches) return;
                entry.mobileOpen = !entry.mobileOpen;
                syncPanels();
                scheduleUpdate();
            });
        });

        function syncPanels() {
            entries.forEach(function(entry){
                if (!entry.mobileToggle) return;
                var open = !mobileViewport.matches || entry.mobileOpen;
                entry.mobileBody.hidden = !open;
                entry.mobileToggle.hidden = !mobileViewport.matches;
                entry.mobileToggle.setAttribute('aria-expanded', String(open));
                entry.mobileToggle.setAttribute('aria-label', (open ? 'Collapse: ' : 'Expand: ') + entry.headingText);
                entry.mobileToggle.textContent = open ? '\u2212' : '+';
            });
        }

        function revealHashSection() {
            if (!mobileViewport.matches) return;
            var target = entries.find(function(entry){
                return entry.mobileToggle && entry.link.hash === window.location.hash;
            });
            if (!target) return;
            target.mobileOpen = true;
            syncPanels();
            requestAnimationFrame(function(){
                target.section.scrollIntoView({ block: 'start', behavior: 'auto' });
            });
        }

        function setActive(active) {
            entries.forEach(function(entry){
                var isActive = entry === active;
                entry.link.classList.toggle('is-active', isActive);
                if (isActive) entry.link.setAttribute('aria-current', 'location');
                else entry.link.removeAttribute('aria-current');
            });
        }

        function updateActive() {
            frame = null;
            var header = document.getElementById('siteHeader');
            var offset = (header ? header.getBoundingClientRect().height : 72) + 32;
            var anchorOffset = parseFloat(window.getComputedStyle(entries[0].section).scrollMarginTop) || 0;
            offset = Math.max(offset, anchorOffset + 2);
            var active = entries[0];
            entries.forEach(function(entry){
                if (entry.section.getBoundingClientRect().top <= offset) active = entry;
            });
            setActive(active);
        }

        function scheduleUpdate() {
            if (frame === null) frame = requestAnimationFrame(updateActive);
        }

        entries.forEach(function(entry){
            entry.link.addEventListener('click', function(event){
                if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                event.preventDefault();
                var hash = entry.link.hash;
                if (window.location.hash !== hash) window.history.pushState(null, '', hash);
                entry.section.setAttribute('tabindex', '-1');
                entry.section.focus({ preventScroll: true });
                entry.section.scrollIntoView({
                    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                    block: 'start'
                });
                setActive(entry);
            });
        });
        window.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate, { passive: true });
        window.addEventListener('hashchange', function(){
            revealHashSection();
            scheduleUpdate();
        });
        function updateViewport() {
            syncPanels();
            revealHashSection();
            scheduleUpdate();
        }
        if (mobileViewport.addEventListener) mobileViewport.addEventListener('change', updateViewport);
        else mobileViewport.addListener(updateViewport);
        syncPanels();
        revealHashSection();
        updateActive();
    });
})();

/* ── Multi-currency price converter ──────────────────────────────────────
   Reads FX data from <body data-fx> (rates relative to GBP, symbols, detected
   default), converts every [data-gbp] price element, and keeps the header
   currency switcher(s) in sync. User choice persists in localStorage. */
(function () {
    function readFx() {
        try {
            var raw = document.body.getAttribute('data-fx');
            return raw ? JSON.parse(raw) : null;
        } catch (e) { return null; }
    }

    var fx = readFx();
    if (!fx || !fx.rates) return;

    // No persistence: every page load starts from GBP. Conversion is a
    // per-visit choice made in the profile rates section only.
    function getCurrency() {
        return 'GBP';
    }

    // Only elements inside a [data-fx-scope] container (profile rates etc.)
    // are ever converted; gallery cards always stay GBP.
    function inScope(el) {
        return !!(el.closest && el.closest('[data-fx-scope]'));
    }

    function format(amount, code) {
        var symbol = (fx.symbols && fx.symbols[code]) || '';
        var isGbp = code === 'GBP';
        var value = isGbp ? amount : Math.ceil(amount / 10) * 10;
        var decimals = isGbp ? (amount % 1 === 0 ? 0 : 2) : 0;
        return symbol + value.toLocaleString('en-GB', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    var currentCode = getCurrency();

    function convertEl(el, code) {
        var gbp = parseFloat(el.getAttribute('data-gbp'));
        if (isNaN(gbp)) return;
        var rate = fx.rates[code] || 1;
        el.textContent = format(gbp * rate, code);
    }

    function apply(code) {
        currentCode = code;
        document.querySelectorAll('[data-fx-scope] [data-gbp]').forEach(function (el) {
            convertEl(el, code);
        });
        document.querySelectorAll('.js-currency-select').forEach(function (sel) {
            if (sel.value !== code) sel.value = code;
        });
        var nonGbp = code !== 'GBP';
        document.querySelectorAll('.js-fx-note').forEach(function (note) {
            note.hidden = !nonGbp;
        });
    }

    // Convert prices injected after load (AJAX cards, infinite scroll, etc.).
    function watchDynamic() {
        if (!('MutationObserver' in window)) return;
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                m.addedNodes.forEach(function (node) {
                    if (node.nodeType !== 1) return;
                    if (node.hasAttribute && node.hasAttribute('data-gbp') && inScope(node)) {
                        convertEl(node, currentCode);
                    }
                    if (node.querySelectorAll) {
                        node.querySelectorAll('[data-gbp]').forEach(function (el) {
                            if (inScope(el)) convertEl(el, currentCode);
                        });
                    }
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    function init() {
        apply(currentCode);
        document.querySelectorAll('.js-currency-select').forEach(function (sel) {
            sel.value = currentCode;
            sel.addEventListener('change', function () {
                apply(this.value);
            });
        });
        watchDynamic();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// ── Incall Escorts slider (location gallery pages, full-size cards) ──
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Splide === 'undefined') return;
    document.querySelectorAll('.incallStaffSlide').forEach(function (el) {
        new Splide(el, {
            gap: 4,
            arrows: false,
            pagination: false,
            fixedWidth: 180,
            mediaQuery: 'min',
            arrowPath: 'm13.4 8.4c0.6-0.5 1.6-0.5 2.2 0l10.5 10.6c0.6 0.6 0.6 1.5 0 2.1l-10.5 10.5c-0.6 0.6-1.6 0.6-2.2 0-0.5-0.6-0.5-1.5 0-2.1l9.5-9.5-9.5-9.4c-0.5-0.6-0.5-1.6 0-2.2z',
            breakpoints: {
                768: {
                    gap: 4,
                    fixedWidth: 260,
                    arrows: true,
                    omitEnd: true
                }
            }
        }).mount();
    });
});
